import uniqueId from "lodash-es/uniqueId";
import { generateFormEffects } from "../tools";
export function registerReactions(form, reactions) {
  const effctor = generateFormEffects(reactions);
  const id = uniqueId("$GLOBAL_EFFECTS_");
  form.addEffects(uniqueId("$GLOBAL_EFFECTS_"), effctor);
  return id;
}
